<template>
  <div v-if="!isIframe" class="header">
    <div class="position-relative content">
      <div class="logo-text">
        <a class="header-logo">
          <b-link :to="{ path: '/trang-chu' }">
            <img src="../../assets/images/logo.png" alt="image" />
          </b-link>
        </a>
        <div class="header-title">HỆ THỐNG QUẢN LÝ NGƯỜI DÙNG</div>
      </div>
      <div class="nav-toggle mt-2" @click="toggleNav()">
        <b-icon icon="list" />
      </div>
      <BaseHeaderAccount />
    </div>
  </div>
</template>

<script>
import {
  addLeftMenuAndOverLayClass,
  removeLeftMenuAndOverlayClass,
} from "@/utils/headerUtils";
import _isEmpty from "lodash/isEmpty";
import BaseHeaderAccount from "@/components/common/BaseHeaderAccount";
import { mapGetters } from "vuex";

export default {
  name: "BaseHeader",
  components: {
    BaseHeaderAccount,
  },
  computed: {
    ...mapGetters({
      user: "common/userInfo",
      isIframe: "common/isIframe",
    }),
  },
  methods: {
    toggleNav() {
      window.addEventListener("resize", () => {
        removeLeftMenuAndOverlayClass();
      });
      if (!_isEmpty(document.getElementsByClassName("left-menu-show"))) {
        removeLeftMenuAndOverlayClass();
      } else {
        addLeftMenuAndOverLayClass();
      }
      document.getElementById("overlay-common") &&
        document
          .getElementById("overlay-common")
          .addEventListener("click", () => {
            if (!_isEmpty(document.getElementsByClassName("left-menu-show"))) {
              removeLeftMenuAndOverlayClass();
            }
          });
    },
  },
};
</script>
